export default __webpack_public_path__ + "static/media/pic4.ebf774c8.png";